import React from 'react';
import Card from '@/components/atoms/UI/Card/Card';
import { BoldTextS, TextS } from '@/pages/designSystem/Fonts';
import { useSelector } from 'react-redux';
import { selectMyDuration, selectUsersAvgDuration } from '@/store/selectors/resultSelectors';
import { useTranslation } from 'react-i18next';

interface DurationProps {}
const ResultDuration: React.FC<DurationProps> = ({}) => {
	const myDuration = useSelector(selectMyDuration);
	const avgDuration = useSelector(selectUsersAvgDuration);

	const { t } = useTranslation();
	const text_my_duration = t('result.my_duration' as string);
	const text_avg_duration = t('result.avg_duration' as string);

	return (
		<>
			{myDuration <= 0 && (
				<Card>
					<TextS>
						{text_my_duration}: <BoldTextS>{myDuration}</BoldTextS>
					</TextS>
					<TextS>
						{text_avg_duration}: <BoldTextS>{avgDuration}</BoldTextS>
					</TextS>
				</Card>
			)}
		</>
	)
}

export default ResultDuration